import { styled } from '@mui/system';
import { Card, Chip, SxProps, Theme } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
    flex: 1,
    maxWidth: 415,
    padding: theme.spacing(3),
    border: '1px solid #e0e0e0',
}));

export const StyledChip = styled(Chip)({
    height: '40px',
    borderRadius: '6px',
    padding: '10px',
    backgroundColor: '#DCF0FF',
    '& .MuiChip-label': {
        fontFamily: 'Readex Pro, sans-serif',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: '#0283FA',
        padding: 0,
    },
});

export const pageStyles: Record<string, SxProps<Theme>> = {
    container: {
        mt: 25,
    },
    title: {
        fontFamily: 'Readex Pro, sans-serif',
        fontWeight: 600,
        fontSize: '34px',
        lineHeight: '100%',
        letterSpacing: '0%',
        width: '840px',
        m: '0 auto 10px',
    },
    subtitle: {
        fontFamily: 'Readex Pro, sans-serif',
        fontWeight: 400,
        fontSize: '20px',
        lineHeight: '100%',
        letterSpacing: '0%',
        width: '840px',
        m: '0 auto 4px',
    },
    sliderBox: {
        maxWidth: 840,
        mx: 'auto',
        mb: 8,
        p: 2,
        bgcolor: '#FFFFFF',
        borderRadius: 2,
        mt: 5,
    },
    sliderLabel: {
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
    },
    sliderControl: {
        width: '95%',
        mx: 'auto',
    },
    cardContainer: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'center',
        alignItems: 'stretch',
        gap: 3,
    },
    titleText: {
        fontFamily: 'Readex Pro, sans-serif',
        fontWeight: 600,
        fontSize: '26px',
        lineHeight: '100%',
        letterSpacing: '0%',
        width: '840px',
        m: '0 auto 0',
    },
    priceText: {
        fontFamily: 'Readex Pro, sans-serif',
        fontWeight: 600,
        fontSize: '34px',
        lineHeight: '100%',
        letterSpacing: '0%',
    },
    monthText: {
        fontFamily: 'Readex Pro, sans-serif',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        letterSpacing: '0%',
    },
    descriptionBox: {
        maxWidth: 355,
        height: 80,
        p: '0 16px',
        backgroundColor: '#FAFBFE',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    descriptionText: {
        lineHeight: '20px',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    featureItem: {
        marginBottom: '-10px',
        alignItems: 'center',
    },
    listItemIcon: {
        minWidth: '32px',
    },
    checkIcon: {
        color: 'success.main',
    },
    featuresTitle: {
        mb: 1,
        fontWeight: 'bold',
    },
};
